import { QRFC } from "./QRFC";

export class QReportsRFC extends QRFC {
  constructor() {
    super();
  }

  InitReportRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
  }

  GetCallName() {
    return "reporting_rfc";
  }

  SetParams(orgName, user, mode, data) {
    this.fMode = mode;
    this.AddParameter("data", data);
    this.AddParameter("mode", mode);
    this.AddParameter("org", orgName);
    this.AddParameter("user", user);
  }

  DoTransactionComplete(response, callBackObj) {
    var r = JSON.parse(response);
    callBackObj?.ReportResult(r);
  }
}
